module.exports = __webpack_public_path__ + "static/media/llanta-desgaste-prematuro-green.aa3052bc.svg";